export const VISIT_STATUS_TO_COLOR_MAP: Record<string, string> = {
    impossible: "#ff0000",
    notYetPlannable: "silver",
    planned: "#00C853",
    plannableOk: "#4EABF5",
    plannableAtRisk: "#F59E0B",
    outOfProtocol: "#DC2626",
    plannableSoon: "#90CAF9",
};

export const ROUTE_LONG_BIKE_COLOR = VISIT_STATUS_TO_COLOR_MAP.outOfProtocol;

export const VISIT_STATUS_TO_COLOR_FOREGROUND_MAP: Record<keyof typeof VISIT_STATUS_TO_COLOR_MAP, string> = {
    notYetPlannable: "black",
    plannableOk: "black",
    plannableAtRisk: "black",
    outOfProtocol: "white",
    impossible: "white",
    planned: "white",
    plannableSoon: "black",
};

export const FIELDWORKER_COLORS = {
    assigned: "#00C853",
    available: "#959595",
} as const;
